/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetStaffBrandDetailsRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/staff_brand_details.pb'
import {GetStaffBrandDetailsResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/staff_brand_details.pb'


export const getStaffBrandDetails = (request: GetStaffBrandDetailsRequest, options?: CashRequestOptions) => post<GetStaffBrandDetailsRequest, GetStaffBrandDetailsResponse>("/cash-app/local/staff/brand-details", request, {...options, rejectOnError: true })